<ng-container *ngFor="let emoji of emojis; let index = index" >
  <span (click)="onClick(emoji)" style="cursor: pointer">{{ emoji }}</span>
</ng-container>
